export default {
  OPERACION_PARCELA: (state, mutation) => {
    state.operacion = mutation.oper
    state.data = mutation.data
  },
}
